import { isFlowRuntimeEnabled } from '../../utils/flowEnabled';
import { userLabel } from '../../utils/userLabel';

export const ROUTE_TYPE_USER = 'user';
export const ROUTE_TYPE_FLOW = 'flow';

export function getUserLabel(user) {
  return userLabel(user);
}

export const defaultCallRoutingForm = {
  id: '',
  label: '',
  matchType: 'extension',
  matchValue: '',
  deviceType: 'doorphone',
  routeType: ROUTE_TYPE_USER,
  routeTo: '',
  routeToLabel: '',
  status: 'active',
};

export function toClientIdentity(userId) {
  const value = String(userId || '').trim();
  if (!value) return '';
  return value.startsWith('user-') ? value : `user-${value}`;
}

export function isFlowRoute(routeType) {
  return String(routeType || '').trim().toLowerCase() === ROUTE_TYPE_FLOW;
}

export function routeToDisplay(route = {}) {
  const label = route.routeToLabel || route.routeTo || '';
  if (isFlowRoute(route.routeType)) {
    return label ? `${label} (Flow)` : 'Flow';
  }
  return label;
}

export function canSaveCallRouting(form = {}) {
  return Boolean(
    String(form.label || '').trim()
    && String(form.matchValue || '').trim()
    && String(form.routeTo || '').trim()
    && String(form.routeType || ROUTE_TYPE_USER).trim()
  );
}

export function inboundRoutingFlowLabel(flow) {
  if (!flow) return '';
  return flow.flowName || flow.name || flow.label || flow.id || '';
}

export function isInboundRoutingFlow(flow) {
  if (!flow || flow.supportsInboundCallRouting === false) return false;
  if (!isFlowRuntimeEnabled(flow)) return false;
  if (flow.supportsInboundCallRouting === true) return true;
  const collections = [].concat(flow.steps || [], flow.actions || [], flow.nodes || []);
  return collections.some((item) => {
    const type = String(item?.type || item?.stepType || '').toLowerCase();
    return type === 'route_call' || type === 'routecall';
  });
}
